import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import DocsExample from '@/components/DocsExample'


import QuillTextEditor from "@/components/common/quillTextEditor";

import Paginate from 'vuejs-paginate-next'
import AppFilter from '@/components/AppFilter.js'
import MgrCdSelectBox from "@/components/common/mgrCdSelectBox";
import MgrCdSelectBox2 from "@/components/common/mgrCdSelectBox2";
import FileUpDownload from "@/components/common/fileUpDownload";
// 엑셀 다운로드 버튼
import GridExcelDownloadBtn from "@/components/button/gridExcelDownloadBtn";
// 기간선택 component
import PeriodSelected from "@/components/common/periodSelected";
// 필터링 키워드 관리 팝업
import FilterKeywordMngModal from "@/components/common/filterKeywordMngModal";

import { AgGridVue } from 'ag-grid-vue3'

import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-balham.css"; // Optional theme CSS
import VueCookies from "vue-cookies";

/* fullcalendar */
import FullCalendar from '@fullcalendar/vue3'

import VueZoomer from 'vue-zoomer'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import specific icons */
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

import VueApexCharts from "vue3-apexcharts";
// The next two lines are optional themes

const app = createApp(App)
app.use(store)
app.use(router)
app.use(CoreuiVue)
app.use(VueCookies);
app.use(VueZoomer);
app.use(VueApexCharts);

app.$cookies.config("7d") // expire 7일 (global 설정)

app.provide('icons', icons)
app.component('CIcon', CIcon)
app.component('DocsExample', DocsExample)

/* datepicker */
app.component('Datepicker', Datepicker)
/* datepicker */

/* 공통코드 selectbox set */
app.component('MgrCdSelectBox', MgrCdSelectBox)
app.component('MgrCdSelectBox2', MgrCdSelectBox2)
/* 공통코드 selectbox set */

/* 공통 파일업/다운 set */
app.component('FileUpDownload', FileUpDownload)
/* 공통 파일업/다운 set */

/* ag-grid */
app.component('AgGridVue', AgGridVue)

/* pagination */
app.component('Paginate', Paginate)
/* pagination */

app.component('QuillTextEditor', QuillTextEditor)

/* fullcalendar */
app.component('FullCalendar', FullCalendar)

/* 엑셀다운로드 버튼 */
app.component('GridExcelDownloadBtn', GridExcelDownloadBtn)
/* 기간선택 component */
app.component('PeriodSelected', PeriodSelected)
/* 필터링 키워드 관리 팝업 */
app.component('FilterKeywordMngModal', FilterKeywordMngModal)


/* add icons to the library */
library.add(fas, far, fab)
app.component('font-awesome-icon', FontAwesomeIcon)

app.config.globalProperties.$filters = AppFilter

app.mount('#app')
